(async () => {
  const sharePageButtons = Array.from(document.querySelectorAll('.js-share-current-page'));

  for (const sharePageButton of sharePageButtons) {
    sharePageButton.addEventListener('click', () => {
      const pageUrl = window.location.href;
      // const pin = generateRandomNumber(2);
      // sharePageButton.innerText = 'Sharing...';
      fetch('https://www.fpapplications.com/sharePage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ pageUrl /*, pin*/ }),
      });
      // .then((res) => {
      //   if (res.ok) {
      //     sharePageButton.innerText = 'Shared! Your PIN is ' + pin;
      //   } else {
      //     sharePageButton.innerText = 'Share failed';
      //   }
      // })
      // .catch((err) => {
      //   console.error('Error sharing page:', err);
      //   sharePageButton.innerText = 'Share failed';
      // });
    });
  }

  function generateRandomNumber(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
})();
